import { useMemo, useState } from "react";
import { Page, DataTable } from "@iq/models";
import useInventoryStore from "../states/inventory";
import { fetchInventory } from "../services/inventoryService";
import InventoryDetails from "../modals/InventoryDetails/InventoryDetails";
import useIsSmallScreen from "../hooks/useIsSmallScreen";
function Inventory() {
    const storedInventory = useInventoryStore((state) => state.inventory);
    const setInventory = useInventoryStore((state) => state.setInventory);
    const [selectedInventory, setSelectedInventory] = useState(null);

    async function refreshInventory() {
        try {
            const payload = await fetchInventory();
            setInventory(payload?.inventory || []);
        } catch (error) {
            console.error("Failed to refresh inventory:", error);
        }
    }

    const inventory = useMemo(() => {
        const rawInventory = Array.isArray(storedInventory)
            ? storedInventory
            : Array.isArray(storedInventory?.inventory)
                ? storedInventory.inventory
                : [];

        return rawInventory.map((item) => ({
            id: item?.product_variant?.id ?? item?.id ?? item?.product?.id ?? 0,
            name: item?.product?.name ?? item?.name ?? "Unknown product",
            sku: item?.product_variant?.sku ?? "",
            quantity: Number(item?.stock ?? item?.quantity ?? 0),
        }));
    }, [storedInventory]);

    const tableConfig = useMemo(() => ({
        columns: [
            {
                key: "id",
                label: "ID",
                accessor: "id",
                width: "0.5fr",
                filterable: true,
            },
            {
                key: "name",
                label: "Name",
                accessor: "name",
                width: "1fr",
                filterable: true,
            },
            {
                key: "sku",
                label: "SKU",
                accessor: "sku",
                width: "1fr",
                filterable: true,
            },
            {
                key: "quantity",
                label: "Quantity",
                accessor: "quantity",
                width: "1fr",
                filterable: true,
            },
        ],
        emptyLabel: "No inventory found.",
    }), []);

    const mobileTableConfig = useMemo(() => ({
        columns: [
            {
                key: "id",
                label: "ID",
                accessor: "id",
                width: "1fr",
                filterable: true,
            },
            {
                key: "name",
                label: "Name",
                accessor: "name",
                width: "4fr",
                filterable: true,
            },
            {
                key: "sku",
                label: "SKU",
                accessor: "sku",
                width: "4fr",
                filterable: true,
            },
            {
                key: "quantity",
                label: "Quantity",
                accessor: "quantity",
                width: "2fr",
                filterable: true,
            },
        ],
        emptyLabel: "No inventory found.",
    }), []);
    const isSmallScreen = useIsSmallScreen();

    return (
        <Page title="Inventory">
            <DataTable
                rowData={inventory}
                rowKey={(item) => item.id}
                tableConfig={isSmallScreen ? mobileTableConfig : tableConfig}
                onRowClick={(item) => {
                    setSelectedInventory(item);
                }}
            />
            <InventoryDetails
                isOpen={!!selectedInventory}
                inventoryItem={selectedInventory}
                onClose={() => setSelectedInventory(null)}
                onSaved={refreshInventory}
            />
        </Page>
    );
}

export default Inventory;